import urlConfig from 'Url';
import { isCsairApp, appFaceAuth, filterPsgName } from '@csair/emp-helpers';
import TicPopUp from 'TicPopUp';
import tips from 'tips';
import Routes from 'Routes';
import { stringify, parse } from 'query-string';
import { isOfficialTicket, session } from 'Utils';

import { getUserInfo } from '../../../modules/actions';

export const CHECK_TICKET = 'CHECK_TICKET';
export const CLEAR_TICKET_INFO = 'CLEAR_TICKET_INFO';
export const CHECK_TICKET_FLIGHT = 'CHECK_TICKET_FLIGHT';
export const SAVE_CHANGE_PROCESS = 'SAVE_CHANGE_PROCESS';
export const CHECK_FACE_AUTH = 'CHECK_FACE_AUTH';
export const CANCEL_CHECKIN = 'CANCEL_CHECKIN';
export const REPLACE_FLIGHT = 'REPLACE_FLIGHT';
export const SAVE_X_PRODUCTS = 'SAVE_X_PRODUCTS';
export const SAVE_PSG_FLIGHT = 'SAVE_PSG_FLIGHT';
export const SAVE_MU_TYPE = 'SAVE_MU_TYPE';
export const SAVE_HU_TYPE = 'SAVE_HU_TYPE';
export const SAVE_MU_FILE = 'SAVE_MU_FILE';
export const SAVE_HU_FILE = 'SAVE_HU_FILE';

export const CREATE_XSO_ORDER = 'CREATE_XSO_ORDER';
export const SAVE_AI_PRAMAS = 'SAVE_AI_PRAMAS';
export const SAVE_DOOR_PRODUCTS = 'SAVE_DOOR_PRODUCTS';
export const UPLOAD_REFUND_FILE = 'UPLOAD_REFUND_FILE';
export const HU_FLIGHT_PROTECTION = 'HU_FLIGHT_PROTECTION';

export function saveChangeProcess(status) {
  return { type: SAVE_CHANGE_PROCESS, status };
}

// 变更、退票航段校验
export function checkTicketFlight(data) {
  const urlParams = parse(
    window.location.hash.slice(window.location.hash.indexOf('?'))
  );
  return {
    type: CHECK_TICKET_FLIGHT,
    payload: {
      request: {
        url:
          urlParams.ticketChangeType === 'refundTicket'
            ? urlParams.channel === 'TPWL'
              ? urlConfig.checkTicketFlightTPWL
              : urlConfig.checkTicketFlight
            : urlConfig.checkTicketFlight,
        method: 'post',
        data,
      },
    },
  };
}

// 清空乘机人和航段数据
export function clearCheckData() {
  return { type: CLEAR_TICKET_INFO };
}

// 取消值机
export function cancelCheckIn(data) {
  return {
    type: CANCEL_CHECKIN,
    payload: {
      request: {
        url: urlConfig.cancelCheckIn,
        method: 'post',
        data,
      },
    },
  };
}

function isNeedGoBack() {
  return (
    window.location.href.indexOf(Routes.ticket.child.endorsedApply.path) !== -1
  );
}

function goback() {
  const { oldLocation } = JSON.parse(
    JSON.parse(window.sessionStorage.getItem('persist:emp')).App
  );
  if (isCsairApp()) {
    try {
      if (!oldLocation.pathname) {
        window.CSNativeObject.closeWebview();
      } else {
        window.history.back();
      }
    } catch (e) { }
  } else {
    window.history.back();
  }
}

/**
 * @description 校验是否需要人脸识别
 * @param {object} authParams
 * @param {bool} nextTrue，默认false
 * @param {func} callback，成功后的回调函数
 */
export function checkFaceAuth(authParams, nextTrue = false, callback, lang) {
  return async function (dispatch, getState) {
    const {
      payload: {
        data: { checkCode },
      },
    } = await dispatch({
      type: CHECK_FACE_AUTH,
      payload: {
        request: {
          url: urlConfig.faceRecognition,
          method: 'post',
          data: Object.assign({}, authParams, {
            nextTrue,
          }),
        },
      },
    });
    if (checkCode === '1') {
      callback({
        needFaceAuth: false,
        faceAuthResult: false,
      });
      return false;
    }
    if (checkCode === '2') {
      TicPopUp(
        lang.title,
        '办理退票需进行人脸识别，若涉嫌非法操作，南航有权追究其法律责任。',
        isNeedGoBack() ? goback : '',
        '',
        [
          {
            text: '确认',
            onPress: () => {
              dispatch(checkFaceAuth(authParams, true, callback, lang));
            },
          },
        ]
      );
      return false;
    }
    if (checkCode === '3') {
      TicPopUp(
        lang.title,
        '您好！该类客票暂不支持自助处理，您可以联系原出票单位退票。',
        isNeedGoBack() ? goback : ''
      );
      return false;
    }
    if (checkCode === '4') {
      appFaceAuth(
        status => {
          if (status === '0' || status === 0) {
            TicPopUp(
              lang.title,
              '人脸认证失败，请重试。如有疑问，请联系南航客服95539。',
              isNeedGoBack() ? goback : ''
            );
            return false;
          }
          if (status === '1' || status === 1) {
            callback({
              needFaceAuth: true,
              faceAuthResult: true,
            });
            return false;
          }
          if (!status || typeof status === 'undefined') {
            if (isNeedGoBack()) goback();
            return false;
          }
        },
        () => {
          TicPopUp(
            lang.title,
            '您好！请更新至最新版的南航App！',
            isNeedGoBack() ? goback : ''
          );
        }
      );
      return false;
    }
  };
}

/**
 * @description 校验获取客票信息
 * @param {string} type 类型
 * @param {object} data 入参
 * @param {object} options
 * @param {object} options.channel 渠道
 * @param {func} callback
 */
function transCabin(name) {
  switch (name) {
    case '经济舱':
      return 'Economy Class';
    case '明珠经济舱':
      return 'Sky Pearl Economy Class';
    case '公务舱':
      return 'Business Class';
    case '头等舱':
      return 'First Class';
    default:
      return name;
      break;
  }
}
export function checkTicket(type, data, options, callback, lang) {
  let isEN = window.sessionStorage.getItem('language') == 'en';
  return async function (dispatch, getState) {
    const isNeed = isNeedGoBack();
    const {
      App: { sysConfig },
      EdorsedApply: { ticketNo, orderNo },
    } = getState();

    const urlParams = parse(
      window.location.hash.slice(window.location.hash.indexOf('?'))
    );

    const url =
      ((urlParams.channel && urlParams.channel === 'TPWL') ||
        (options.channel && options.channel === 'TPWL')) &&
        (urlParams.ticketChangeType === 'refundTicket' ||
          (type === 'r' && options.channel && options.channel === 'TPWL'))
        ? urlConfig.checkOrderTicketTPWL
        : urlConfig.checkOrderTicket;

    if (
      (ticketNo && ticketNo === data.ticketNo) ||
      (orderNo && orderNo === data.orderNo)
    ) {
      callback();
      return false;
    }
    try {
      const {
        payload: {
          data: {
            checkResult,
            checkCode,
            checkMsg,
            error,
            ticketFlights,
            ticketType,
            invalidCode,
            gloOrederVo,
            isCeAirline,
            airportTransferList,
          },
        },
      } = await dispatch({
        type: CHECK_TICKET,
        closeLoading: isNeed,
        payload: {
          request: {
            url,
            method: 'post',
            data,
          },
        },
        ticketNo: data.ticketNo,
        orderNo: data.orderNo,
      }).then(data => {
        dispatch(getUserInfo());
        return data;
      });
      if (checkResult === 'Y' || checkResult === 'S') {
        if (ticketFlights) {
          const {
            flightList,
            odList,
            psgList,
            odFlag,
            currency,
          } = ticketFlights;
          if (psgList && psgList.length > 0 && type === 'c') {
            if (
              options.channel === 'appos' &&
              options.channel !== ticketFlights.psgList[0].orderingSiteCode
            ) {
              // TicPopUp(lang.title, lang.tipP5);
              TicPopUp(lang.title, lang.tipP5, '', '', [
                {
                  text: lang.confirm,
                  onPress: () => {
                    window.$sensors.sensors.track('popup_click', {
                      popup_area: '可退改列表页-提示弹窗',
                      popup_type: '提示弹窗',
                      popup_title: lang.title,
                      popup_content: lang.tipP5,
                      click_type: lang.confirm,
                      // target_url: process.env.TRC_work_order2 + `channel=web_2&query=dxxzrg&value1=${resUrl}`
                    });
                    window.location.hash.indexOf('#/ticket/updateDetail') > -1
                      ? ''
                      : goback();
                  },
                },
              ]);
              return false;
            }
            if (
              options.channel === 'appos' &&
              options.channel === psgList[0].orderingSiteCode
            ) {
              session('orderingSiteCode', 'appos');
            }
          }
          flightList.forEach(item => {
            item._flightClass_ = isEN
              ? transCabin(item.flightClass)
              : item.flightClass;
          });
          // 国际票
          if (
            psgList[0].domestic === 1 &&
            type === 'c' &&
            sysConfig.supportInterVolChange
          ) {
            let _ticketType = 'd';
            if (ticketFlights.isMileage === 'Y0') {
              // Y0动态里程，按照之前的里程流程逻辑
              _ticketType = 'm';
            }
            if (ticketFlights.isMileage === 'Y1') {
              // 固定里程，新航班按价格的展示
              _ticketType = 'm1';
            } else if (isOfficialTicket(ticketFlights.psgList)) {
              _ticketType = 'o';
            } else {
              _ticketType = 'd';
            }
            window.sessionStorage.setItem(
              'emp-mobile',
              JSON.stringify({
                ticket: {
                  base: {
                    ticketNo: data.ticketNo,
                    orderNo: data.orderNo,
                    odFlag,
                    ticketType: _ticketType,
                    ticketClass: ticketType,
                    currency: currency,
                  },
                  flightList: odFlag ? odList : flightList,
                  psgList: psgList,
                  gloOrederVo,
                  airportTransferList,
                },
              })
            );
            let href = `${
              // window.location.href = `${
              process.env.REACT_APP_APP
              }msite/#/selectSegPsg?${stringify({
                orderNo: data.orderNo || '',
                ticketNo: data.ticketNo || '',
                scopeCodes: data.scopeCodes,
                ...(data.attribute1 ? { packOrderNo: data.packOrderNo } : {}),
                ...(options.channel ? { channel: options.channel } : {}),
              })}`;
            if (
              /(InvalidStudentTicket)|(InvalidLabourTicket)/.test(invalidCode)
            ) {
              TicPopUp(
                lang.title,
                checkMsg,
                goback,
                '',
                [
                  {
                    text: type === 'c' ? '继续变更' : '继续退票',
                    onPress: () => {
                      window.location.href = href;
                    },
                  },
                  {
                    text: '取消',
                    onPress: () => {
                      window.location.hash.indexOf('#/ticket/updateDetail') > -1
                        ? ''
                        : goback();
                    },
                  },
                ],
                '',
                {},
                false
              );
            } else {
              window.location.href = href;
            }
            return false;
          }
        }

        if (
          /(twinCityFly)|(EmployeeareaFlight)|(HapplyFly)|(HapplyFlyPc_LessthantwoNull)|(HapplyFlydataException)|(HapplyFlyPc_Lessthantwo)|(InvalidStudentTicket)|(InvalidLabourTicket)|(NoShowHappyFlyNumVoid)|(NoShowCsairHappyFlyVoid)/.test(
            checkCode
          ) &&
          isNeed
        ) {
          TicPopUp(lang.title, checkMsg, goback, '', [
            {
              text: type === 'c' ? '继续变更' : '继续退票',
              onPress: () => {
                callback();
              },
            },
            {
              text: '取消',
              onPress: () => {
                window.location.hash.indexOf('#/ticket/updateDetail') > -1
                  ? ''
                  : goback();
              },
            },
          ]);
          return false;
        }

        // if (
        //   /(NoShowHappyFlyNumVoid)|(NoShowCsairHappyFlyVoid)/.test(checkCode) &&
        //   isNeed
        // ) {
        //   TicPopUp(lang.title, checkMsg, goback, '', [
        //     {
        //       text: type === 'c' ? '继续变更' : '继续退票',
        //       onPress: () => {
        //         callback();
        //       },
        //     },
        //     {
        //       text: '取消',
        //       onPress: () => {
        //         window.location.hash.indexOf('#/ticket/updateDetail') > -1
        //           ? ''
        //           : goback();
        //       },
        //     },
        //   ]);
        //   return false;
        // }

        if (checkCode === 'specialMsg' && isNeed) {
          TicPopUp(lang.title, checkMsg, goback, '', [
            {
              text: lang.keepsubmit,
              onPress: () => {
                callback();
              },
            },
          ]);
          return false;
        }

        if (
          /(HappyFlyNoRefund)|(HappyFlyNoRefundZYTP)|(HappyFlyNoChange)|(HappyFlyNoZYBG)/.test(
            checkCode
          ) &&
          isNeed
        ) {
          TicPopUp(
            lang.title,
            checkMsg ? checkMsg : error ? error.errorMsg : '系统异常',
            isNeedGoBack() ? goback : ''
          );
        }

        // if (window.location.hash.indexOf('#/ticket/updateDetail') > -1 && isCeAirline === "3" && type === 'c') {
        //   TicPopUp(lang.title, lang.updateDetail.huChangeTip, '', '', [
        //     {
        //       text: '确定',
        //       onPress: () => {
        //         callback();
        //       },
        //     },
        //     {
        //       text: '取消',
        //       onPress: () => {
        //       },
        //     },
        //   ]);
        //   return false;
        // }

        callback();
      } else {
        TicPopUp(
          lang.title,
          checkMsg ? checkMsg : error ? error.errorMsg : '系统异常',
          isNeedGoBack() ? goback : ''
        );
      }
    } catch (error) {
      console.log('接口异常');
    }
  };
}

/**
 * @description 获取客票
 * @param {string} type r 退票 c 变更
 * @param {object} ticketParams checkOrderTicket api参数
 * @param {object} authParams faceRecognition api参数
 * @param {func} callback 成功回调函数
 * @param {object} options
 * @param {object} options.closeLoad
 * @param {object} options.faceAuthResult 人脸认证结果
 */
export function getTicketInfo(
  type,
  ticketParams,
  authParams,
  callback,
  options = {
    faceAuthResult: false,
    channel: '',
  },
  lang
) {
  return async function (dispatch, getState) {
    if (
      type === 'r' &&
      isCsairApp() &&
      !options.faceAuthResult &&
      getState().App.sysConfig.faceAuth
    ) {
      dispatch(
        checkFaceAuth(
          authParams,
          false,
          function (faceAuth) {
            if (
              !faceAuth.needFaceAuth ||
              (faceAuth.needFaceAuth && faceAuth.faceAuthResult)
            ) {
              dispatch(
                checkTicket(
                  type,
                  ticketParams,
                  {
                    channel: options.channel,
                  },
                  function () {
                    callback(faceAuth.faceAuthResult);
                  },
                  lang
                )
              );
            }
          },
          lang
        )
      );
      return false;
    }
    dispatch(
      checkTicket(
        type,
        ticketParams,
        {
          channel: options.channel,
        },
        callback,
        lang
      )
    );
  };
}

// 替换指定航段
export function replaceFlight(index, flight) {
  return { type: REPLACE_FLIGHT, index, flight };
}

// 保存x产品
export function saveXproducts(products, soProduct, htProduct, trainPro) {
  return { type: SAVE_X_PRODUCTS, products, soProduct, htProduct, trainPro };
}
// 保存door产品
export function saveDoorproducts(selectDoorList) {
  return { type: SAVE_DOOR_PRODUCTS, selectDoorList };
}
// 保存x产品
export function savePsgFlight(selectedPsg, selectedFlight) {
  return { type: SAVE_PSG_FLIGHT, selectedPsg, selectedFlight };
}
export function saveMutype(muRefundType, muRefundReason, qtReason) {
  return { type: SAVE_MU_TYPE, muRefundType, muRefundReason, qtReason };
}

export function saveMuFile(muFileList) {
  return { type: SAVE_MU_FILE, muFileList };
}
export function saveHuFile(huFileList) {
  return { type: SAVE_HU_FILE, huFileList };
}
export function saveHutype(huRefundType, huRefundReason, beizhu) {
  return { type: SAVE_HU_TYPE, huRefundType, huRefundReason, beizhu };
}
export function saveAiPramas(data) {
  return { type: SAVE_AI_PRAMAS, data };
}
export function createXSOOrder(data) {
  return {
    type: CREATE_XSO_ORDER,
    payload: {
      request: {
        url: urlConfig.createXSOOrder,
        method: 'post',
        data,
      },
    },
  };
}

export function uploadRefundFile(data) {
  return {
    type: UPLOAD_REFUND_FILE,
    payload: {
      request: {
        url: urlConfig.uploadRefundFile,
        method: 'post',
        data,
        processData: false,
        contentType: false,
      },
    },
  };
}

export function HuFlightProtection(data) {
  return {
    type: HU_FLIGHT_PROTECTION,
    payload: {
      request: {
        url: urlConfig.HuFlightProtectionCheck,
        method: 'post',
        data,
      },
    },
  };
}

// WEBPACK FOOTER //
// ./src/routes/routes/endorsedApply/modules/actions.js



// WEBPACK FOOTER //
// ./src/routes/routes/endorsedApply/modules/actions.js